import React, { createContext, useContext, useState, useEffect } from 'react';
import { fpost, handleLogoutFn, setAuthToken } from '../../axios/axiosCalls';
import secureLocalStorage from 'react-secure-storage';
import { isValidToken } from './Jwt';
import axios from 'axios';

// Create Auth Context
export const AuthContext = createContext();

// Custom hook to use the AuthContext
export const useAuth = () => useContext(AuthContext);

// AuthProvider component to wrap around the app
export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true); // New loading state

  // Load user from secureLocalStorage if token exists and is valid
  useEffect(() => {
    const authToken = secureLocalStorage.getItem('authToken');
    console.log('authToken retrieved from secureLocalStorage:', authToken); // Debugging

    if (authToken && isValidToken(authToken)) {
      const savedUser = secureLocalStorage.getItem('user');
      console.log('savedUser retrieved:', savedUser); // Debugging

      if (savedUser) {
        setUser(JSON.parse(savedUser));
        console.log('User state set from savedUser:', JSON.parse(savedUser)); // Debugging
      } else {
        setUser({ authToken });
        console.log('User state set with authToken only:', { authToken }); // Debugging
      }

      const refreshToken = secureLocalStorage.getItem('refreshToken');
      console.log('refreshToken retrieved:', refreshToken); // Debugging
      setAuthToken(authToken, refreshToken);
    } else {
      console.log('Token invalid or not present, logging out.'); // Debugging
      setUser(null);
      handleLogoutFn();
    }

    setLoading(false); // Authentication check completed
  }, []);
  const BASE_URL = import.meta.env.VITE_API_BASE_URL || '';

  const login = async (email, password) => {
    try {
      // Send login request using fpost from axiosCalls.js
      const response = await axios.post(
        `${BASE_URL}/api/v2/login`,
        { email, password, },
      );

      console.log('Login response:', response.data.data); // Debugging

      const { token: authToken, refreshToken, user } = response.data.data;

      // Save tokens using setAuthToken function in axiosCalls.js
      setAuthToken(authToken, refreshToken);
      secureLocalStorage.setItem('user', JSON.stringify(user));

      // Update user state
      setUser(user);
      console.log('User set in context after login:', user); // Debugging
    } catch (error) {
      console.error('Login error:', error);
      throw error; // Rethrow the error to be handled in the calling component
    }
  };
  const signup = async (formData) => {
    try {
      // Send signup request using fpost from axiosCalls.js
      const response = await fpost({
        url: '/api/v2/register',
        data: { ...formData, userType: 2 },
      });

      console.log('Signup response:', response.data.data); // Debugging

      // const { token: authToken, refreshToken, user } = response.data.data;

      // // Save tokens using setAuthToken function in axiosCalls.js
      // setAuthToken(authToken, refreshToken);
      // secureLocalStorage.setItem('user', JSON.stringify(user));

      // // Update user state
      // setUser(user);
      console.log('User set in context after signup:', user); // Debugging
    } catch (error) {
      console.error('Signup error:', error);
      throw error; // Rethrow the error to be handled in the calling component
    }
  };
  const logout = () => {
    console.log('Logging out...'); // Debugging
    handleLogoutFn();
    setUser(null);
  };

  // Optional: Log when user state changes
  useEffect(() => {
    console.log('Current user state:', user);
  }, [user]);

  return (
    <AuthContext.Provider value={{ user, login, logout, loading, signup }}>
      {children}
    </AuthContext.Provider>
  );
};